var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGw(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 40,
    fill: "none",
    viewBox: "0 0 54 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ce1126",
    d: "M.3 0h18.4v40H.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcd116",
    d: "M18.7 0h35v20h-35z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009e49",
    d: "M18.7 20h35v20h-35z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000001",
    d: "m9.5 13.3-2 6.4 3.1 1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000001",
    d: "m9.5 13.3 2 6.4-3.1 1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000001",
    d: "M15.8 18H9.2v3.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000001",
    d: "m15.8 18-5.4 3.9-2-2.7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000001",
    d: "m13.4 25.4-2-6.3-3.2 1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000001",
    d: "m13.4 25.4-5.4-4 2-2.6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000001",
    d: "m5.6 25.4 5.4-4-2-2.6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000001",
    d: "m5.6 25.4 2-6.3 3.2 1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000001",
    d: "m3.2 18 5.4 3.9 2-2.7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000001",
    d: "M3.2 18h6.6v3.3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.3 0h53.3v40H.3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGw);
export default __webpack_public_path__ + "static/media/gw.30f17e67078f4a739e8735e4ba6a402d.svg";
export { ForwardRef as ReactComponent };